import { render, staticRenderFns } from "./Webservice.vue?vue&type=template&id=ed68429e&scoped=true&"
import script from "./Webservice.vue?vue&type=script&lang=js&"
export * from "./Webservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed68429e",
  null
  
)

export default component.exports